// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PDownSquareOutlinedSvg from "@fishx/icons-svg/es/asn/PDownSquareOutlined";
import FishxIcon from '../components/FishxIcon';

var PDownSquareOutlined = function PDownSquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PDownSquareOutlinedSvg
  }));
};

PDownSquareOutlined.displayName = 'PDownSquareOutlined';
export default React.forwardRef(PDownSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PDownSquareOutlined.js
// module id = 3341
// module chunks = 0